import { Component, EventEmitter, inject, Input, Output } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { KeeniconComponent } from "@shared/keenicon/keenicon.component";
import { NgClass } from "@angular/common";
import { NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { Ability } from "@casl/ability";
import { E_ACTIONS, E_SUBJECT } from "@core/enums/Permission.enum";

@Component({
  selector: "app-cab-button",
  templateUrl: "./cab-button.component.html",
  styleUrls: ["./cab-button.component.scss"],
  standalone: true,
  imports: [NgClass, KeeniconComponent, TranslateModule, NgbTooltipModule],
})
export class CabButtonComponent {
  @Input() subject: E_SUBJECT;
  @Input() action: E_ACTIONS;
  @Input() label = "";
  @Input() isPending = false;
  @Input() widthFull = false;
  @Input() isLightIcon = false;
  @Input() color = "";
  @Input() icon = "";
  @Input() title = "";
  @Input() tooltipPosition: "start" | "end" | "bottom" | "top" = "end";
  @Input() tooltipText = "";
  @Input() samllicon = "";
  @Input() size: "lg" | "sm" | "" = "sm";
  @Input() customClass: string | string[] | Set<string> = "";
  @Input() disabled = false;
  @Input() type: "button" | "reset" | "submit" = "button";
  @Input() iconType: "outline" | "solid" | "duotone" = "duotone";
  @Input() styleType:
    | "success"
    | "primary"
    | "secondary"
    | "danger"
    | "light"
    | "info"
    | "warning"
    | "dark"
    | ""
    | string = "success";
  @Output() btnClick = new EventEmitter<void>();
  ability = inject(Ability);

  hasShowButton() {
    if (!this.subject || !this.action) return true;
    return this.ability.can(this.action, this.subject);
  }

  onClick() {
    if (!this.disabled) {
      this.btnClick.emit();
    }
  }
}
